<div class="grv-form-field container">
  <input
    #input
    type="checkbox"
    [class]="inputClass"
    [id]="inputId"
    [required]="required"
    [checked]="checked"
    [indeterminate]="indeterminate"
    [disabled]="disabled"
    [tabIndex]="tabIndex"
    [attr.value]="value"
    [attr.name]="name"
    [attr.aria-label]="ariaLabel"
    [attr.aria-checked]="_getAriaChecked()"
    (change)="_onInteractionEvent($event)"
    (click)="_onInputClick($event)"
  />
  <label [id]="inputId + '_label'" [attr.for]="inputId" [class]="labelClass" #label>
    <ng-content></ng-content>
  </label>
</div>
